import React, { useEffect, useState } from 'react'
import { TeacherProps } from './TeacherInterface'
import ViewModal from '../Modal/ViewModal'
import { getAssignedSubject } from '../../api/teacher'
import { LoaderComponent } from '../../utils/Helper'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  teacher: TeacherProps
}

export const TeacherDetailsModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  teacher,
}) => {
  const [assignedSubject, setAssignedSubject] = useState([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const fetchData = async () => {
      if (teacher?.id) {
        setLoading(true)
        getAssignedSubject(teacher.id)
          .then((res) => {
            const assignedSubjects = res?.data?.data.map((item: any) => ({
              value: item?.id,
              label: item?.title,
            }))

            setAssignedSubject(assignedSubjects)
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    }

    fetchData()
  }, [teacher?.id])

  if (!isOpen) return null

  const fullName = teacher.first_name + ' ' + teacher.last_name

  return (
    <ViewModal
      title={fullName || 'Details'}
      isOpen={isOpen}
      onClose={onClose}
      body={
        <div>
          {loading ? (
            <LoaderComponent
              size='sm'
              label='Loading assigned subjects…'
            />
          ) : (
            <>
              <div className='flex justify-center mb-4'>
                {teacher.profile_photo && (
                  <img
                    src={
                      typeof teacher.profile_photo === 'string'
                        ? teacher.profile_photo
                        : URL.createObjectURL(teacher.profile_photo)
                    }
                    alt={fullName}
                    className='w-24 h-24 rounded-full object-cover'
                  />
                )}
              </div>

              <h3 className='text-2xl font-semibold text-center mb-2'>
                {fullName}
              </h3>
              <div className='py-4 mt-4 border-t border-gray-300'>
                <div className='max-w-md mx-auto bg-white rounded-lg overflow-hidden shadow-sm'>
                  <table className='min-w-full divide-y divide-gray-200'>
                    <tbody className='bg-white divide-y divide-gray-200'>
                      <tr>
                        <td className='px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-500'>
                          Email
                        </td>
                        <td className='px-4 py-2 whitespace-nowrap text-sm text-gray-900'>
                          {teacher.email}
                        </td>
                      </tr>
                      <tr>
                        <td className='px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-500'>
                          Phone
                        </td>
                        <td className='px-4 py-2 whitespace-nowrap text-sm text-gray-900'>
                          {teacher.phone_number}
                        </td>
                      </tr>
                      <tr>
                        <td className='px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-500'>
                          Address
                        </td>
                        <td className='px-4 py-2 whitespace-nowrap text-sm text-gray-900'>
                          {teacher.address}
                        </td>
                      </tr>
                      <tr>
                        <td className='px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-500'>
                          Subjects
                        </td>
                        <td className='flex flex-wrap gap-2 px-4 py-2 text-sm text-gray-900'>
                          {assignedSubject.length
                            ? assignedSubject.map((item: any) => {
                                return (
                                  <p className='p-2 border border-gray-300 text-left bg-gray-50 w-[fit-content] text-[12px] rounded-md'>
                                    {item.label}
                                  </p>
                                )
                              })
                            : 'N/A'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      }
    />
  )
}
